import store from '@/store'
import useFunctions from '@/composables/useFunctions'
import sgccApi from "@/api/sgccApi"

const isAuthenticatedGuard = async( to, from, next ) => {

    const { checkTokenExpiration } = useFunctions()

    const idToken = localStorage.getItem('idToken')

    if (!idToken) {
        return to.name === "auth.login" ? next() : next({ name: 'auth.login' })
    }

    
    
    if (checkTokenExpiration()) {
        await store.dispatch('auth/logout')
        return next({ name: 'auth.login' })
    }

    if (!sgccApi.defaults.headers.common["Authorization"] && idToken) {
        sgccApi.defaults.headers.common["Authorization"] = "Bearer " + idToken
    }

    const { ok } = await store.dispatch('auth/getUserWithToken')
    
    if (!ok) {
        await store.dispatch('auth/logout')
        return next({ name: 'auth.login' })
    }
    
    return to.name !== "auth.login" ? next() : (to.name === "auth.login" && ok ? next({ name: 'sgcc.home' }) : next({ name: 'auth.login' }))
    

}

export default isAuthenticatedGuard